<template>
  <div class="result-content">
    <div class="select_wrap" style="width: 100%">
      <div class="search_wrap select_box">
        <!-- 运动员类型 -->
        <select
          v-model="selectVal.goalie"
          class="yioks_select"
          @change="changePlayerTyper"
        >
          <option
            v-for="(item, index) in playerTypeList"
            :key="index"
            :value="item.key"
          >
            {{ item.name }}
          </option>
        </select>

        <!-- 年龄段 -->
        <select
          v-model="selectVal.t_age"
          class="yioks_select"
        >
          <option
            v-for="(item, index) in ageList"
            :key="index"
            :value="item.key"
          >
            {{ item.name }}
          </option>
        </select>

        <!-- 指标 -->
        <select
          v-model="selectVal.indicator_uuid"
          class="yioks_select"
          @change="changeMetrics"
        >
          <template v-for="(item, index) in metricsList">
            <option
              v-if="selectVal.goalie === 0"
              :key="index"
              :value="item.uuid"
            >
              {{ item.indicatorName }}
            </option>
          </template>

        </select>

        <!-- 页大小 -->
        <select
          v-model="selectVal.size"
          class="yioks_select"
          @change="changePagesize"
        >
          <option
            v-for="(item, index) in pagesizeList"
            :key="index"
            :value="item.key"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="yioks_btn" @click="searchFunction" style="width:100px;padding:10px 27px;">查找</div>
    </div>

    <div class="list_wrap" v-if="isShowResult">
      <div class="table" v-if="isShowTable">
        <div class="thead">
          <div class="tr">
            <div class="th seq">
              <strong>序号</strong>
            </div>
            <div class="th name">
              <strong>姓名</strong>
            </div>
            <div class="th gender">
              <strong>性别</strong>
            </div>
            <div class="th idNumber">
              <strong>身份证号</strong>
            </div>
            <div class="th metrics">
              <strong style="display: flex">
                <span style="display: flex;align-items: center">{{ searchMetrics }}</span>
                <span style="display: flex;flex-direction: column;margin-left: 10px">
                    <span @click="orderBy('up')" style="cursor: pointer;height: 12px;width: 12px;">
                      <v-icon name="chevron-up" scale="1"></v-icon>
                    </span>
                    <span @click="orderBy('down')" style="cursor: pointer;height: 12px;width: 12px;">
                      <v-icon name="chevron-down" scale="1"></v-icon>
                    </span>
                </span>
              </strong>
            </div>
            <div class="th opt">
              <strong>操作</strong>
            </div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <yioks-empty h="400px" v-if="isEmpty"/>
            <div class="tbodyWrap" v-else>
              <div class="tbody">
                <div class="tr" v-for="(item, index) in tableList" :key="index">
                  <div class="td seq">
                    <p>{{ index + 1 }}</p>
                  </div>
                  <div class="td name">
                    <p>{{ item.idName }}</p>
                  </div>
                  <div class="td gender">
                    <p>{{ item.gender }}</p>
                  </div>
                  <div class="td idNumber">
                    <p>{{ item.idNumber | filterIdNumberPrivacy }}</p>
                  </div>
                  <div class="td metrics">
                    <p v-if="selectVal.indicator_uuid === 'ranking'">{{ item.ranking ||  '--' }}</p>
                    <p v-else-if="selectVal.indicator_uuid === 'resultScore'">{{ item.score || '--' }}</p>
                    <p v-else>{{ item.testResult || '--' }}</p>
                  </div>
                  <div class="td opt">
                    <p>
                      <span class="item" @click="findDetails(item)">查看</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <yioks-loading v-if="isLoading"/>
    </div>

    <yioks-dialog
      title="运动员能力分析详细信息"
      :show-flag="isShowDialog"
      :isShowCancel="false"
      :width="'860px'"
      :successBtn="'确定'"
      @hideDialog="hideDialogFunction"
    >
      <div class="dialog-content">
        <vue-scroll>

          <div class="info">
            <div class="col">
              <span>测试批次：{{body.templateTitle}}</span>
              <span>测试时间：{{body.testTime | time() }}</span>
            </div>
            <div class="col">
              <span>测试联系人：{{body.linkMen}}</span>
              <span>测试联系人手机号：<yioks-privacy-text type="phone" :value="body.linkMenPhone" /></span>
            </div>  
            <div class="col">
              <span>单位：{{ body.organShortName + ' ' + body.youthShortName}}</span>
              <span>测试海拔 ：{{body.testRegion | testRegionFilter}}</span>
            </div>
            <div class="col">
              <span>测试地点 ：{{body.testAddress || '--'}}</span>
<!--              <span style="display: flex;">-->
<!--                <span v-if="body.bodyResult">排名 ：{{body.bodyResult.ranking || '&#45;&#45;'}}</span>-->
<!--                <span v-if="body.bodyResult">总分 ：{{body.bodyResult.score || '&#45;&#45;'}}</span>-->
<!--              </span>-->
            </div>
          </div>
          <div class="box-wrap" v-if="infoVos.length">
            <div class="box"
                 v-for="(item,index) in infoVos"
                 :key="index"
            >
              <p class="indicatorName" v-if="item.score">{{item.indicatorName}}&nbsp;/&nbsp;得分</p>
              <p class="indicatorName" v-else>{{item.indicatorName}}</p>
              <p class="content">{{ item.testResult || '--' }} &nbsp; <span v-if="item.score">/&nbsp;{{item.score}}</span></p>
            </div>
          </div>
        </vue-scroll>
      </div>
    </yioks-dialog>
  </div>
</template>

<script>
  import {
    playerTypeOptions,
    ageOptionsGuanfang,
    metricsOptionsGuanfang,
    pagesizeOptions,
    getMetricsNameGuanfang,
  } from './selecOptions'
  import body from '@/api/body'
  import { filterIdNumber, positionStatus, testRegionFilter } from '@/utils/yioks_filter'
  import 'vue-awesome/icons/chevron-up'
  import 'vue-awesome/icons/chevron-down'

  export default {
    name: 'ResultList',

    data () {
      return {
        isShowTable: true,
        selectVal: {
          t_age: '2025/10',
          goalie: 0,
          age: 10,
          testYear: 2025,
          indicator_uuid: '',
          order: 'DESC', // 正序ASC 倒序 DESC
          official: 1, // 官方
          size: 10,
        },
        playerTypeList: playerTypeOptions,
        ageList: ageOptionsGuanfang,
        // metricsList: metricsOptionsGuanfang,
        metricsList: [],
        pagesizeList: pagesizeOptions,

        tableList: [],
        isShowResult: false,
        isLoading: false,

        total: 0,
        page: 0,
        pageSize: 20,
        isShowDialog: false,
        selectItem: {},
        infoVos: [],
        body: {}
      }
    },

    computed: {
      searchMetrics () {
        return this.getMetricsNameGuanfang(this.selectVal.indicator_uuid)
      },
      isEmpty () {
        if (this.tableList.length) {
          return false
        } else {
          return true
        }
      },
    },


    filters: {
      testRegionFilter,
    },

    components: {
      Pagination: () => import('@/components/Pagination'),
    },

    watch: {
      page () {
        this.changeQuery()
      },
  
      'selectVal.t_age': {
        handler(newVal, oldVal) {
          const [ testYear, age  ] = newVal.split('/')
          this.$set(this.selectVal, 'age', age)
          this.$set(this.selectVal, 'testYear', testYear)
          this.isShowResult = true;
          this.changeQuery(true)
        }
      }
    },

    created () {
      this.getTemplateSuper();
    },

    methods: {
      getMetricsNameGuanfang (key) {
        return this.metricsList.find(item => item.uuid === key)?this.metricsList.find(item => item.uuid === key).indicatorName : '--'
      },
      getTemplateSuper() {
        body.getTemplateSuper().then((res) => {
          if (res.length) {
            var arr = res.filter((item) => item.templateOfficial==1);
            var len = arr.length;
            this.metricsList = arr[len-1].indicatorList;
            this.$set(this.selectVal, 'indicator_uuid', this.metricsList[0].uuid);
          }
        });
      },
      changePlayerTyper () {
        this.isShowResult = true
        this.changeQuery(true)
      },

      // changeAge () {
      //   this.isShowResult = true
      //   this.changeQuery(true)
      // },

      changeMetrics () {
        // const { indicator_uuid } = this.selectVal;
        // let defaultOrder = ''; // 默认不排序
        // switch (indicator_uuid) {
        //   case '0029acb9119042c18b3ac7f8bbcb4716':  // 臂展 降序
        //     defaultOrder = 'DESC';
        //     break;
        //   case '9f9c14670b2541b78a80a0bb74a1f079':  // 臂展 升序
        //     defaultOrder = 'ASC';
        //     break;
        //   case '9a14e8938b67429997e13765a221658d':  // 30m跑 升序
        //     defaultOrder = 'ASC';
        //     break;
        //   case 'e7ea9924bbb44a3383b2782cd4dbc478':  // 引体向上 降序
        //     defaultOrder = 'DESC';
        //     break;
        //   case '0bef00ce3cc6417790dfccc2c25bdcce':  // 纵跳 降序
        //     defaultOrder = 'DESC';
        //     break;
        //   case 'a1867c0284ef4f7e99642c322a77f0dd':  // YOYO测试 降序
        //     defaultOrder = 'DESC';
        //     break;
        //   case 'f219af266bb14f0eaa5cc2a366e11402':  // 体前屈 降序
        //     defaultOrder = 'DESC';
        //     break;
        //   case '1761adff3e6c4071b7965654820b40f0':  // 左箭头跑 升序
        //     defaultOrder = 'ASC';
        //     break;
        //   case '7da599bc85a6466da6f6b0fbc295b07b':  // 右箭头跑 升序
        //     defaultOrder = 'ASC';
        //     break;
        //   default:
        //     defaultOrder = 'DESC';
        //     break
        // }
        // this.$set( this.selectVal, 'order', defaultOrder);

        this.isShowResult = true;
        this.changeQuery(true)
      },

      changePagesize () {
        this.isShowResult = true
        this.pageSize = this.selectVal.size
        this.changeQuery(true)
      },

      searchFunction () {
        this.changeQuery(true)
        this.isShowResult = true
      },

      changeQuery (flag) {
        const fullPath = this.$route.fullPath
        flag && (this.page = 0)
        this.$router.replace({
          path: fullPath,
          query: {
            ...this.$route.query,
            ...this.selectVal,
            page: this.page,
          },
        })

        this.loadTableData()
      },
      orderBy(status){
        this.selectVal.order = status ==='up' ? "ASC" : "DESC";
        this.changeQuery(true)
      },
      /* 加载后台数据 */
      loadTableData () {
        this.isLoading = true
        const {
          page,
          size,
          order,
          indicator_uuid,
          goalie,
          official,
          age,
          testYear,
        } = this.$route.query
        const params = {
          testYear,
          age,
          goalie,
          indicator_uuid,
          order,
          size,
          official,
          page,
        }
        body
          .getplayerBodyDataListSearch(params)
          .then((res) => {
            this.isLoading = false
            this.total = res.totalElements
            this.pageSize = res.size
            this.tableList = res.content
          })
          .catch((err) => {
            this.isLoading = false
            console.error(err)
          })
      },

      /* 加载详情 */
      findDetails (item) {
        this.selectItem = item
        const { dataUuid, playerUuid } = item;
        body.getplayerInfo( { dataUuid, playerUuid } ).then(res => {
          const { infoVos, ...rest } = res;
          this.infoVos = infoVos;
          this.body = rest;
        }).catch(err => {
          console.log(err)
        })
        this.isShowDialog = true
      },

      hideDialogFunction (flag, ok) {
        if (ok) {
          this.isShowDialog = flag
        } else {
          this.isShowDialog = flag
        }
      },

      /* 获取运动员详细信息 */
      loadPlayerInfo() {

      },
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';

  // @import '~@/assets/css/base';
  .result-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .select_wrap {
    padding-bottom: 20px;
    .select_box{
      .yioks_select{
        width:170px;
      }
    }
  }

  .list_wrap {
    flex: 1;
    overflow: hidden;
    width: 100%;
    height: 540px;
    padding-top: 20px;
  }

  .table {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;

    // margin: 30px 0 0;

    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom: 15px;
      /* flex 1 */
      /* overflow hidden */
    }

    .tbodyWrap {
      display: block;
      // padding: 0 40px;
    }

    .tbody {
      display: block;
      width: 810px;
      margin-left: auto;
      margin-right: auto;
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
    }

    .th, .td {
      height: 100%;
      /* flex: 1 1 auto; */
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }

    .seq {
      width: 10%;
    }

    .name {
      width: 20%;
    }

    .gender {
      width: 12%;
    }

    .idNumber {
      width: 23%;
    }

    .metrics {
      width: 20%;
    }

    .opt {
      width: 15%;

      p {
        width: 100%;
        text-align: center;

        .item {
          cursor: pointer;
          user-select: none;
          color: $green_color;
        }

        .split {
          margin: 0 5px;
        }
      }
    }
  }
  .el-dialog__body
    padding: 0px 20px 20px;
  .dialog-content
    width 100%
    height 520px
    padding 10px 0px 20px
    .box-wrap
      flex 1
      display flex
      flex-wrap wrap
      justify-content space-around
      padding 10px 5px 0
      border 1px solid #4cd964

      .box
        width 103px
        display flex
        flex-direction column
        // border-right 1px solid #FFF
        // border 1px solid #FFF
        margin-bottom 10px

        p
          flex 1
          display flex
          align-items center
          justify-content center
          min-height 40px
          text-align center

        .content
          border-top 1px dashed #FF9900

        .indicatorName
          color #4cd964


  .info
    flex 1
    border 1px solid #4cd964
    border-bottom: none
  .col
    border-bottom 1px solid #4cd964
    // border-right 1px solid #FFF
    padding 16px 15px
    display flex
    justify-content space-around
    span
      display inline-block
      width 100%
    &:last-child
      border-bottom 0
  .playerImg
    display flex
    flex-direction column
    justify-content center
    align-items center
    img
      width 120px
      height 120px
      /*height 1.2rem*/
      border-radius 50%
      padding 10px
    p
      text-align center
</style>
